export const SET_PASSWORD = 'SET_PASSWORD'
export const SET_FILE_URL = 'SET_FILE_URL'
export const UPDATE_ACCOUNT_TRIGGER = 'UPDATE_ACCOUNT_TRIGGER'
export const SET_CAMPAIGNS_FILTER = 'SET_CAMPAIGNS_FILTER'
export const REFRESH_NOTIFICATIONS = 'REFRESH_NOTIFICATIONS'
export const SET_PLATFORMS_FILTER = 'SET_PLATFORMS_FILTER'
export const SET_BRANDS_NAME_FILTER = 'SET_BRANDS_NAME_FILTER'
export const SET_BRANDS_ID_FILTER = 'SET_BRANDS_ID_FILTER'
export const SET_ADVERTISER_CAMPAIGN_NAME = 'SET_ADVERTISER_CAMPAIGN_NAME'
export const SET_ADVERTISER_CAMPAIGN_ID = 'SET_ADVERTISER_CAMPAIGN_ID'

export const setPassword = payload => dispatch =>
  dispatch({
    type: SET_PASSWORD,
    payload: payload
  })
export const setFileURL = payload => dispatch =>
  dispatch({
    type: SET_FILE_URL,
    payload: payload
  })
export const updateAccount = payload => dispatch =>
  dispatch({
    type: UPDATE_ACCOUNT_TRIGGER,
    payload: payload
  })
export const setBrandNameFilter = payload => dispatch =>
  dispatch({
    type: SET_BRANDS_NAME_FILTER,
    payload: payload
  })

export const setBrandIDFilter = payload => dispatch =>
  dispatch({
    type: SET_BRANDS_ID_FILTER,
    payload: payload
  })

export const setCampaignFilter = payload => dispatch =>
  dispatch({
    type: SET_CAMPAIGNS_FILTER,
    payload: payload
  })

export const setPlatformsFilter = payload => dispatch => {
  dispatch({
    type: SET_PLATFORMS_FILTER,
    payload: payload
  })
}
export const refreshNotifications = () => dispatch =>
  dispatch({
    type: REFRESH_NOTIFICATIONS
  })

export const setAdvertiserCampaignName = payload => dispatch =>
  dispatch({
    type: SET_ADVERTISER_CAMPAIGN_NAME,
    payload: payload
  })

export const setAdvertiserCampaignId = payload => dispatch =>
  dispatch({
    type: SET_ADVERTISER_CAMPAIGN_ID,
    payload: payload
  })
